import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import InfoBox from './InfoBox'

const TabSwitch = (props) => {
  const { tabSwitch, setTabSwitch, options, size = 'medium', disabled = false, disabledTooltip = null, translationKey = null, classNames = '', style = {} } = props
  const { t } = useTranslation()

  // return
  return (
    <InfoBox
      body={disabledTooltip}
      enabled={disabledTooltip}
      withAnchor={false}
      classNames="d-inline-block"
    >
      <div onClick={(event) => event.stopPropagation()} className={`tab-switch ${classNames} ${disabled ? 'disabled' : ''} ${size}`} style={style}>
        {options.map((option) => {
          // Plain strings resolve their label from translationKey (or show
          // as-is) — an object escape hatch for callers whose state value
          // doesn't match its translation key suffix (e.g. legacy value
          // names) to supply an already-resolved label directly.
          const isObjectOption = option !== null && typeof option === 'object'
          const value = isObjectOption ? option.value : option
          const label = isObjectOption
            ? option.label
            : translationKey
              ? t(`${translationKey}.${option}`)
              : option

          return (
            <button
              type="button"
              key={value}
              onClick={() => {
                setTabSwitch(value)
              }}
              className={`tab-switch_button ${tabSwitch === value ? 'active' : ''} ${size}`}
              disabled={disabled}
            >
              {label}
            </button>
          )
        })}
      </div>
    </InfoBox>
  )
}

export default TabSwitch

TabSwitch.propTypes = {
  tabSwitch: PropTypes.string.isRequired,
  setTabSwitch: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ value: PropTypes.string.isRequired, label: PropTypes.node.isRequired }),
    ]),
  ).isRequired,
  disabled: PropTypes.bool,
  disabledTooltip: PropTypes.string,
}